import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 2H22.2263V11H2.22632V2ZM8.22827 5.5H6.22437V7.50391H8.22827V5.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.22632 13H22.2263V14.5997C21.4762 14.2163 20.6265 14 19.7263 14C16.6888 14 14.2263 16.4624 14.2263 19.5C14.2263 20.4002 14.4426 21.2499 14.826 22H2.22632V13ZM8.22827 16.5H6.22437V18.5039H8.22827V16.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.7218 18.0813L17.6005 15.96L16.1863 17.3742L18.3076 19.4955L16.1863 21.6168L17.6005 23.031L19.7218 20.9097L21.8431 23.031L23.2573 21.6168L21.136 19.4955L23.2573 17.3742L21.8431 15.96L19.7218 18.0813Z"}}]};

const DataErrorFilled = Vue.extend<IconProps>({
  name: 'DataErrorFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'data-error-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DataErrorFilled;
